import { APIPersonalAutoApplicationForm } from 'types/api.types';
import { BinderSectionData } from '../hooks/useBinderSectionData';
import { processValidation } from '../utils/helpers';

export const processUnlistedVehiclesData = (
  applicationData: APIPersonalAutoApplicationForm,
  validation?: Validation,
): BinderSectionData => {
  const vehiclesSummary = applicationData?.vehicles_summary;
  const vehicles = applicationData?.vehicles || [];

  // Check vehicle counts
  const totalVehiclesInHousehold = vehiclesSummary.total_vehicles || 0;
  const totalVehiclesOnApplication = vehicles.length;
  const validationData = processValidation(validation);
  const totalVehiclesListed12Months =
    applicationData.unlisted_vehicles.length + applicationData.vehicles.length;

  return {
    title: 'Unlisted vehicles',
    description: 'Check to account for any vehicles not listed on application.',
    isValid: validationData.isValid,
    message: validationData.message,
    data: {
      summary: {
        totalVehiclesInHousehold,
        totalVehiclesOnApplication,
        totalVehiclesListed12Months,
      },
    },
  };
};
